var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGreenPen = function SvgGreenPen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.3411 4.97789L19.0224 3.65918C18.583 3.21973 18.0071 3 17.4313 3C16.8554 3 16.2795 3.21973 15.8404 3.65883L13.2217 6.27762L12 7.4993L3.45179 16.0472L3.00531 20.0627C2.94906 20.5683 3.34738 21 3.84202 21C3.87331 21 3.90495 20.9982 3.93659 20.9947L7.94931 20.5514L16.5007 12L17.722 10.7787L20.3408 8.15988C21.2197 7.28098 21.2197 5.85645 20.3411 4.97789ZM7.17482 18.9395L4.79897 19.2018L5.0637 16.822L13.1932 8.6925L14.2837 7.60195L16.398 9.71625L15.3075 10.8068L7.17482 18.9395ZM19.1476 6.96633L17.5909 8.52305L15.4769 6.40875L17.0336 4.85203C17.1771 4.70859 17.3444 4.68715 17.4313 4.68715C17.5181 4.68715 17.6858 4.70859 17.8289 4.85203L19.1476 6.17074C19.367 6.39047 19.367 6.7473 19.1476 6.96633Z",
    fill: "#028BB7"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGreenPen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/green-pen.d9768819.svg";
export { ForwardRef as ReactComponent };